import { ChangeEvent, useRef, useState } from "react";
import "./styles.css";
import React from "react";

export interface checkProps {
    id: string;
    label?: string;
    options: { label: string; value: string }[];
    value: string[];
    onChange: (value: string[]) => any;
    requiredIdentifier?: boolean;
    errorMessage: string;
    disabled?: boolean;
    height?: string;
}

function CheckBoxList(props: checkProps) {
    const [filterValue, setFilterValue] = useState("");
    const [filteredCheckboxList, setFilteredCheckboxList] = useState<{ label: string; value: string }[]>([]);
    const [fieldValues, setFieldValues] = useState(props.value);
    const [errorMessage, setErrorMessage] = useState("");
    const checkboxRefs = useRef<HTMLInputElement[] | null[]>(new Array());
    React.useEffect(() => {
        setFieldValues(props.value);
        setErrorMessage(props.errorMessage);
    }, [props.value, props.errorMessage]);

    const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
        let updatedVal = [...fieldValues];
        if (e.target.checked) {
            updatedVal.push(e.target.value);
        } else {
            updatedVal = updatedVal.filter(x => x != e.target.value);
        }
        let updatedList = props.options.filter(x => updatedVal.includes(x.value));
        updatedList.sort((a, b) => a.label.localeCompare(b.label));
        updatedVal = updatedList.map(x => x.value);
        setFieldValues(updatedVal);
        props.onChange(updatedVal);
    };

    React.useEffect(() => {
        setFilteredCheckboxList(props.options.sort((a, b) => a.label.localeCompare(b.label)));
    }, []);
    function OnFilter(filterValue: string) {
        if (filterValue.length > 2) {
            let filtertedList = props.options;
            let filtered = filtertedList.filter(x => x.label.toLowerCase().includes(filterValue.toLowerCase()));
            let selectedOptions = [];
            for (var i = 0; i < filtered.length; i++) {
                if (fieldValues.includes(filtered[i].value)) {
                    selectedOptions.push(filtered[i].value);
                }
            }
            setFilteredCheckboxList(filtered);
            //setFieldValues(selectedOptions);
        } else {
            let filtertedList = props.options;
            let filtered = filtertedList;
            let selectedOptions = [];
            for (var i = 0; i < filtered.length; i++) {
                if (fieldValues.includes(filtered[i].value)) {
                    selectedOptions.push(filtered[i].value);
                }
            }
            setFilteredCheckboxList(filtered);
            // setFieldValues(selectedOptions);
        }
    }
    const selectAll = () => {
        let allValues = filteredCheckboxList.sort((a, b) => a.label.localeCompare(b.label)).map(x => x.value);
        setFieldValues(allValues);
        props.onChange(allValues);
    };
    const deSelectAll = () => {
        setFieldValues([]);
        props.onChange([]);
    };
    return (
        <div
            className="textBoxContainer"
            key={"Main" + props.id}
        >
            {props.label && props.label != "" && (
                <div className="textBoxCol1">
                    <label className="g-label">{props.label}</label>
                    <small className="asterisk">{props.requiredIdentifier ? "*" : ""}</small>
                </div>
            )}
            <div className="textBoxCol2">
                <div className="filterWrapper">
                    <div>filter:</div>
                    <div>
                        <input
                            type="text"
                            className="g-TextBox-default"
                            style={{ height: "12px", padding: "2px" }}
                            onChange={e => OnFilter(e.currentTarget.value)}
                        ></input>
                    </div>
                </div>
                <div style={{ width: "50%", float: "left" }}>
                    <div style={{ padding: "6px 0px 6px 0px" }}>
                        <b>Available Options:</b>
                    </div>
                    <div style={{ padding: "0px 0px 6px 0px", overflowY: "auto", height: props.height ?? "115px" }}>
                        <div>
                            {filteredCheckboxList.map((x, index) => {
                                return (
                                    <>
                                        <input
                                            type="checkbox"
                                            disabled={props.disabled}
                                            className={
                                                !(errorMessage == "")
                                                    ? "g-Checkbox-default validationFailed "
                                                    : "g-Checkbox-default "
                                            }
                                            onChange={handleInputChange}
                                            value={x.value}
                                            title={errorMessage}
                                            style={{ float: "left" }}
                                            checked={fieldValues.includes(x.value)}
                                            ref={el => {
                                                // Ensure the index is valid and assign the element
                                                if (el) {
                                                    checkboxRefs.current[index] = el;
                                                }
                                            }}
                                        />
                                        <div style={{ float: "left", marginTop: "3px" }}>{x.label}</div>
                                        <br style={{ clear: "both" }} />
                                    </>
                                );
                            })}
                        </div>
                    </div>
                </div>
                <div style={{ width: "50%", float: "left" }}>
                    <div style={{ marginLeft: "10px" }}>
                        <div style={{ padding: "6px 0px 6px 0px" }}>
                            <b>Selected Options:</b>
                        </div>
                        <div style={{ padding: "0px 0px 6px 0px", overflowY: "auto", height: props.height ?? "115px" }}>
                            <ul>
                                {fieldValues.map((value, index) => (
                                    <li key={index}>
                                        {} {props.options.find(x => x.value === value)?.label}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
                <div style={{ paddingTop: "10px", clear: "both", paddingBottom: "10px" }}>
                    <button
                        type="button"
                        className="g-btn btn-primary"
                        onClick={selectAll}
                    >
                        Select All
                    </button>{" "}
                    &nbsp; &nbsp;
                    <button
                        type="button"
                        className="g-btn btn-default"
                        onClick={deSelectAll}
                    >
                        Deselect All
                    </button>
                </div>
            </div>
        </div>
    );
}
export default CheckBoxList;
